  import { DictType } from 'core-lib/types/Helper';
  import qs from 'qs';
  import { FilterType } from '../types/sortAndFilters';

  type ListingQueryType = {
    order?: DictType[];
    filters?: DictType[];
  };

  const formatFilter = (elem: DictType) => {
    const obj = {};
    Object.entries(elem).forEach(([key, value]) => {
      if (key === 'condition') {
        obj['condition_type'] = value;
      } else {
        obj['field'] = key;
        obj['value'] = value;
      }
    });
    return obj;
  };

  const formatFilterGroups = (listing: any[], format = true) => {
    const outArr = [];
    listing?.forEach((item) => {
      outArr.push({
        filters: format ? [formatFilter(item)] : [item],
      });
    });
    return outArr;
  };

  const addBaseIndexToQuery = (
    parsedQuery,
    baseIndex = -1,
    isNewListing = false
  ) => {
    if (baseIndex <= 0) {
      baseIndex = parsedQuery?.searchCriteria?.filter_groups?.length
        ? parsedQuery.searchCriteria.filter_groups.length - 1
        : 0;
    }
    parsedQuery.baseIndex = baseIndex;
    parsedQuery.isNewListing = isNewListing;
    return `${qs.stringify(parsedQuery)}`;
  };

  export const formatListingQuery = ({ order, filters }: ListingQueryType) => {
    const searchCriteria = {};
    if (order) {
      searchCriteria['sortOrders'] = order;
    }
    if (filters) {
      searchCriteria['filter_groups'] = formatFilterGroups(filters);
    }
    const query = {
      searchCriteria,
    };
    return addBaseIndexToQuery(query, -1, true);
  };

  export const appendNewFilterToQuery = (query, filter: DictType, index = -1) => {
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups;

    const formattedFilter = {
      filters: [formatFilter(filter)],
    };

    index >= 0
      ? (filterGroups[index] = formattedFilter)
      : filterGroups.push(formattedFilter);

    parsedQuery.searchCriteria.filter_groups = filterGroups;
    return addBaseIndexToQuery(parsedQuery, index);
  };

  export const removeFilterFromQuery = (query, filter: DictType) => {
    filter = formatFilter(filter);
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups ?? [];
    const output = [];
    for (let i = 0; i < filterGroups?.length; i++) {
      let filterItem = filterGroups?.[i]?.filters;
      const temp = [];
      for (let j = 0; j < filterItem?.length; j++) {
        const item = filterItem?.[j];
        if (item?.field === filter?.field && item?.value === filter?.value) {
          continue;
        }
        temp.push(item);
      }
      if (temp.length) {
        output.push({
          filters: temp,
        });
      }
    }
    parsedQuery.searchCriteria.filter_groups = output;
    return addBaseIndexToQuery(parsedQuery, output.length - 1);
  };

  // to be used only when filters from filterPopup are changed
  export const handleFilterChange = (query, selectedFilters: FilterType[]) => {
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups ?? [];
    const output = [];
    if (filterGroups.length) {
      const baseIndex = parsedQuery?.baseIndex ?? 0;
      // always append the parent filters
      for (let i = 0; i <= baseIndex; i++) {
        output.push(filterGroups[i]);
      }
    }

    // creating a deep copy to preserve keys, dirty work!
    let deepCopy = selectedFilters.map((item) => ({ ...item }));

    deepCopy = deepCopy?.map((item) => {
      delete item.category_id;
      return item;
    });

    const groupedObj = deepCopy.reduce((acc, obj) => {
      const key = obj['field'];
      if (!acc[key]) {
        acc[key] = [obj];
      } else {
        acc[key].push(obj);
      }
      return acc;
    }, {});

    const formattedFilterGroups = Object.values(groupedObj)?.map((item) => ({
      filters: item,
    }));

    output.push(...formattedFilterGroups);

    parsedQuery.searchCriteria.filter_groups = output;
    return qs.stringify(parsedQuery);
  };

  export const getParentCategoryId = (query) => {
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups;

    for (let i = 0; i < filterGroups?.length; i++) {
      const filterItem = filterGroups?.[i]?.filters;
      for (let j = 0; j < filterItem?.length; j++) {
        const item = filterItem?.[j];
        if (item?.field === 'category_id') {
          return item?.value;
        }
      }
    }

    return '';
  };

  export const getLastSelectedCategoryId = (query) => {
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups;

    for (let i = filterGroups.length - 1; i >= 0; i--) {
      const filterItem = filterGroups?.[i]?.filters;
      for (let j = filterItem.length - 1; j >= 0; j--) {
        const item = filterItem?.[j];
        if (item?.field === 'category_id') {
          return item?.value;
        }
      }
    }

    return '';
  };

  export const appendNewSortToQuery = (query, sort: DictType, index = -1) => {
    const parsedQuery: any = qs.parse(query);
    const sortOrders = parsedQuery?.searchCriteria?.sortOrders ?? [];

    index >= 0 ? (sortOrders[index] = sort) : sortOrders.push(sort);

    parsedQuery.searchCriteria.sortOrders = sortOrders;
    return qs.stringify(parsedQuery);
  };

  export const appendVisibilityQuery = (query, filter) => {
    const parsedQuery: any = qs.parse(query);
    const filterGroups = parsedQuery?.searchCriteria?.filter_groups;

    const formattedFilter = {
      filters: [formatFilter(filter)],
    };

    filterGroups?.push(formattedFilter);

    parsedQuery.searchCriteria.filter_groups = filterGroups;
    return qs.stringify(parsedQuery);
  };

  export default formatListingQuery;
